// removed by extract-text-webpack-plugin
module.exports = {"root":"cardStack__root--3Qciw","card":"cardStack__card--3Sr15","overlay":"cardStack__overlay--1I6ll","mobileFrameIcon":"cardStack__mobileFrameIcon--Fq07n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/CardStack/cardStack.css
// module id = 0D+Q
// module chunks = 0